export const StopCircle04 = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
   <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <g clipPath="url(#clip0_1813_3795)">
         <path
            d="M14 0C6.28017 0 0 6.28017 0 14C0 21.7198 6.28017 28 14 28C21.7198 28 28 21.7198 28 14C28 6.28017 21.7198 0 14 0ZM14 25.6667C7.567 25.6667 2.33333 20.433 2.33333 14C2.33333 7.567 7.567 2.33333 14 2.33333C20.433 2.33333 25.6667 7.567 25.6667 14C25.6667 20.433 20.433 25.6667 14 25.6667ZM16.3333 8.16667H11.6667C9.737 8.16667 8.16667 9.737 8.16667 11.6667V16.3333C8.16667 18.263 9.737 19.8333 11.6667 19.8333H16.3333C18.263 19.8333 19.8333 18.263 19.8333 16.3333V11.6667C19.8333 9.737 18.263 8.16667 16.3333 8.16667ZM17.5 16.3333C17.5 16.9762 16.9762 17.5 16.3333 17.5H11.6667C11.0238 17.5 10.5 16.9762 10.5 16.3333V11.6667C10.5 11.0238 11.0238 10.5 11.6667 10.5H16.3333C16.9762 10.5 17.5 11.0238 17.5 11.6667V16.3333Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_1813_3795">
            <rect width="28" height="28" fill="white" />
         </clipPath>
      </defs>
   </svg>
)
